(function () {
  const productsFilters = (section) => {
    if (!section || !section.classList.contains('popular-products-section')) {
      return;
    }
    const filters = section.querySelectorAll('.filters__item');
    const wrappers = section.querySelectorAll('.popular-products__wrapper--filters');

    const onToggleTab = (event) => {
      event.preventDefault();
      const item = event.currentTarget;
      if (!item || !item.classList.contains('filters__item')) return;
      const filterTarget = item.dataset.filterTarget;

      filters.forEach((filterEl) => {
        filterEl.classList.remove('filters__item_active');
      });
      item.classList.add('filters__item_active');

      wrappers.forEach((wrapperEl) => {
        wrapperEl.classList.remove('active');
      });
      wrappers.forEach((wrapperEl) => {
        if (wrapperEl.dataset.filterTarget == filterTarget) {
          wrapperEl.classList.add('active');
        }
      });
    };

    filters.forEach((item) => {
      item.addEventListener('click', onToggleTab);
    });
    if (window.innerWidth < 768) {
      const firstTab = filters[0];
      firstTab.click();
    }
  };

  productsFilters(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    productsFilters(event.target);
  });
})();


// carousel
(function () {
  const initSlider = () => {
    let productSlider;
    const productSliders = document.querySelectorAll('.popular-products__swiper');

    productSliders.forEach((slider, index) => {
       const wrapper = slider.closest('.popular-products__wrapper--filters');
       const paginationEl = wrapper ? wrapper.querySelector('.popular-products__pagination') : slider.querySelector('.popular-products__pagination');
       
       // Check if we're on mobile and configure grid layout
       const isMobile = window.innerWidth < 768;
       
      productSlider = new Swiper(slider, {
        navigation: {
          nextEl: ".popular-products__button-next",
          prevEl: ".popular-products__button-prev",
        },
        pagination: {
          el: paginationEl,
          type: 'fraction',
        },
        slidesPerView: 2,
        slidesPerGroup: 2,
        
        breakpoints: {
          0: {
            spaceBetween: 8,
            slidesPerView: 2,
            slidesPerGroup: 2,
            grid: {
              rows: 2,
              fill: 'row'
            },
          },
          768: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            autoplay: false,
            grid: false,
            spaceBetween: 8,
          },
          1024: {
            slidesPerView: 5,
            slidesPerGroup: 1,
          }
        }
      });
    });
  };

  const destroySlider = () => {
    const productSliders = document.querySelectorAll('.popular-products__swiper');

    productSliders.forEach((slider, index) => {
      if (slider.swiper !== undefined) slider.swiper.destroy();
    });
  };

  const initSection = () => {
    const sections = document.querySelectorAll('.section__popular-products');

    const sectionResizeObserver = new ResizeObserver((entries) => {
      destroySlider();
      initSlider();
    });

    destroySlider();
    initSlider();

    sections.forEach(item => {
      sectionResizeObserver.observe(item);
    });
  };

  initSection();

  document.addEventListener('shopify:section:load', function () {
    initSection();
  });
})();


